export default __webpack_public_path__ + "static/media/Rushing waters_primary.fa21a566.jpg";